const chineseTranslationContent = () => {
  return {
    copy: {
      comma: {
        gpcr: {
          dayOne: '11月15日（五）',
          dayTwo: '11月16日（六）',
          dayThree: '11月17日（日）',
        },
      },
      preSignInPage: {
        firstScreen: `<div class="px-[24px]">
              <div class="text-center font-aktiv-grotesk font-semibold text-[28px] md:text-[36px] leading-[36px] md:leading-[44px]">欢迎使用</div>\
                <div class="flex flex-row justify-center mx-auto items-end">
                  <div class="font-aktiv-grotesk font-bold text-[40px] md:text-[60px] leading-[40px] md:leading-[60px]" style="color: #2B2E79;">累代</div>
                  <span class="font-aktiv-grotesk font-semibold text-[32px] md:text-[48px] leading-[40px] md:leading-[60px]">&nbsp;App</span>
                </div>
              <img src="/assets/images/presignin/pre-signin-page-1.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;"/>
              <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px]">\
                门训“累代”\
                <span class="whitespace-nowrap md:whitespace-auto">建立“强壮教会”</span>\
              </div>\
            </div>`,
        secondScreen: `<div class="pt-[8px] px-[24px]">\
              <div class="w-[90vw] md:w-[432px] text-center font-aktiv-grotesk font-semibold text-[28px] md:text-[36px] leading-[36px] md:leading-[44px] mx-auto">\
                是时候打造<b>更年轻</b>、<br/><b>更强壮</b>的教会！\
              </div>\
              <img src="/assets/images/presignin/pre-signin-page-2.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
              <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px] mx-auto">\
                使用“累代”App获取最新的特会资讯。\
              </div>\
            </div>`,
        thirdScreen: `<div class="pt-[8px] px-[24px]">\
              <div class="w-[90vw] md:w-[432px] mx-auto text-center font-aktiv-grotesk font-semibold text-[28px] md:text-[36px] leading-[36px] md:leading-[44px] mx-auto">\
                特会结束后，<br/>惊喜继续……\
              </div>\
              <img src="/assets/images/presignin/pre-signin-page-3.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
              <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px] mx-auto">\
                通过App继续获取“累代”和“强壮教会”的独家资源！\
              </div>\
            </div>\
            </div>`,
        nextButton: '下一步',
        loginButton: '登录',
      },
      homePage: {
        profile: '个人资料',
        profileDropdown: {
          profile: '简介',
          language: '语言',
          conference: '特会',
          logout: '退出',
        },
        conferenceType: {
          title: '特会',
          gpcr: {
            name: 'GenerationS Pastors Conference Regional',
          },
          gpc: {
            name: 'GenerationS Pastors Conference',
          },
          gic: {
            name: 'GenerationS Implementation Community',
          },
        },
        mainLayout: {
          topNav: {
            experiences: '体验',
            photoDrop: 'PhotoDrop',
            updates: '更新',
          },
          scheduleSection: {
            title: '行程表',
            schedulePanel: {
              endOfDay: '第{ day }天结束',
              tillNextTime: '下次见！',
              seeYouTomorrow: '明天见！',
              seeYouNextYear: '2025年再见！',
              viewSessionResources: `想要重温课堂资源？<br />请前往`,
              viewSessionResourcesPage: '“资源”页面',
              seeYouSoon: '很高兴与你相聚！再会！🤩',
              cantWaitToSeeYou: '你好！我们迫不及待想见到你！',
              // applyNow: "立即报名",
              happeningNow: '现在进行 ',
              goToScheduleButton: '前往行程表',
              viewScheduleButton: '查看行程表',
              viewNextDayScheduleButton: '查看明天的行程表',
            },
          },
          registration: {
            bannerName: 'registration.png',
          },
          worshipSongs: {
            availableOnYoutube: '可在YouTube观看',
            titleImgUrl: '../../../public/assets/images/home/playlist-zh.svg',
          },
          kickOffSection: {
            title: `<p class="text-[32px] text-left leading-[40px] text-blue font-aktiv-grotesk-medium pb-4">
                          在我们开始前 <br class="hidden lg:block"/>...
                        </p>`,
            description: `<p class="text-[16px] text-left lg:w-[320px] mx-auto leading-[24px] text-blue pb-5 font-aktiv-grotesk-regular">
                                观看这段短片，快速了解“累代”！<br /> 你已准备好迎接具有影响力的三天！😊
                              </p>`,
            downloadVideo: '下载短片',
            downloadThumbnail:
              'https://cdn.generationsmvmt.com/images/app/gpcr-pre-watch-thumbnail-zh.jpg',
            downloadLink:
              'https://cdn.generationsmvmt.com/videos/conference-app/gpcr-pre-watch-zh.mp4',
          },
          experiences: {},
          usefulLinks: {
            title: '实用链接',
            links: {
              gettingAround: '神之心教会指南 🚶🏻‍♂️',
              mapLink: 'https://cdn.generationsmvmt.com/docs/zh/HOGC-Map.pdf',
              appGuidedTour: '应用程序导览',
              giving: '奉献',
              busSchedule: '接驳车时间表',
              busSchedulePdf:
                'https://cdn.generationsmvmt.com/docs/GPCR-2024-Shuttle-Bus-Schedule-ZH.pdf',
            },
          },
          appGuidedTour: {
            startTour: '开始导览',
            skipTour: '跳过导览',
            skipButton: '跳过',
            backButton: '上一步',
            nextButton: '下一步',
            endButton: '结束',
            stepPill: {
              stepText: '步骤',
              ofText: '/',
            },
            homeTourTextStep0SCS: `
                <div>
                    <img src="../../../assets/images/guided-tour/HOGC_SG.svg" alt="HOGC" />
                    <br>
                    <div style="text-align:center; margin-left:auto; margin-right:auto; color:#231F20; font-size: 24px; font-weight: 500; line-height: 28px;">欢迎来到</div>
                    <img style="padding-bottom:18px;" src="../../../assets/images/gpcr/gpcr-2024-logo-dark.png" alt="Generations" />
                    <div style="padding-bottom:12px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">“累代”牧师特会App让你查看行程表、特会资料和你被分配的体验。</div>
                    <div style="padding-bottom:24px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">快速导览！</div>
                </div>
              `,
            homeTourTextStep0GC: `
                <div>
                    <img src="../../../assets/images/guided-tour/HOGC_SG.svg" alt="HOGC" />
                    <br>
                    <div style="text-align:center; margin-left:auto; margin-right:auto; color:#231F20; font-size: 24px; font-weight: 500; line-height: 28px;">欢迎来到</div>
                    <img style="padding-bottom:18px;" src="../../../assets/images/gpcr/gpcr-2024-logo-dark.png" alt="Generations" />
                    <div style="padding-bottom:12px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">“累代”牧师特会App让你查看行程表、特会资料和你被分配的体验。</div>
                    <div style="padding-bottom:24px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">快速导览！</div>
                </div>
              `,
            homeTourTextStep1: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">行程表</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">随时掌握特会的每日行程！</span> <br>`,
            homeTourTextStep2: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">体验</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">窥看幕后，看看“累代”和“强壮教会”的原则如何活灵活现！点击这里查看你被分配的体验。</span> <br>`,
            homeTourTextStep3: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">PhotoDrop</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">这里可浏览专属于你的特会照片——照片将实时更新！</span> <br>`,
            homeTourTextStep4: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">开始之前……</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">观看视频，了解建立“累代”和“强壮教会”所需的思维转换！</span> <br>`,
            homeTourTextStep5: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">简介和配置</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">你可以在这里更新你的联系方式，并选择你喜欢的语言！</span> <br> <br>`,
            scheduleTourStep1: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">行程表</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">查看完整的特会行程表。</span>`,
            scheduleTourStep2: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">行程表（每日）</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">查看课堂时间和地点。</span>`,
            scheduleTourStep3: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">课堂资源</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">浏览“查看课堂资源”，你便准备就绪！</span>`,
          },
        },
      },
      languagePage: {
        title: '语言',
        english: '英文',
        chinese: '中文（简体）',
        thailand: '泰文',
      },
      settingsPage: {
        title: '设置',
        general: {
          title: '通用',
          language: '语言',
          conferenceSelector: '选择会议',
        },
        support: {
          title: '支持',
          enquiry: '咨询',
          appGuidedTour: '应用导览',
          privacyPolicy: '隐私政策',
          termsOfUse: '使用条款',
        },
        logout: '登出',
      },
      profilePage: {
        showQr: '显示二维码',
        personalQr: '个人二维码',
        editProfile: '编辑资料',
        addImage: '设置新照片',
        displayName: `显示名称（必填）`,
        emptyName: '告诉我们你的名字！',
        organization: '教会/机构',
        title: '职衔',
        addEmail: '添加邮箱',
        addSocials: '添加社交媒体',
        editEmail: '编辑邮箱',
        editSocials: '编辑社交媒体',
        email: '电邮',
        showMyEmail: '显示我的电邮',
        accountLoginEmail: '登录邮箱',
        socials: '社群媒体',
        socialMedia: {
          addSocialsTitle: '添加社群账号',
          addInstagram: '添加Instagram',
          addFacebook: '添加Facebook',
          addX: '添加X',
          addLinkedIn: '添加LinkedIn',
        },
        saveChanges: '保存更改',
        unsavedTitle: '放弃更改？',
        unsavedBody: '您有未保存的更改。如果现在离开，更改将会丢失。',
        unsavedKeepEditing: '继续编辑',
        unsavedDiscard: '放弃更改',
      },
      announcementPage: {
        title: '最新更新',
        announcementCard: {
          newLabel: '全新',
          today: '今天,',
        },
      },
      resourcesPage: {
        title: '资源',
        filterBy: '筛选条件',
        filterSection: {
          topics: '专题',
          sessions: '课堂',
          day: '第{ i }天：',
          all: '全部',
          session: '课堂',
        },
        searchContent: {
          searchingStringText: `搜索结果为 "{searchTerm}"`,
          noResourcesSearchText: `你搜索的 "{searchTerm}" 未返回任何结果。`,
          noOfResourcesFound: `找到 {count} 个资源`,
        },
        videoPage: {
          videoChapters: '视频章节',
          yellowTag: {
            exclusive: '独家',
            audioOnly: '仅限音频',
          },
          shareButton: '分享',
        },
        description:
          '欢迎来到“累代”和“强壮教会”的一站式平台。使用这里的讲道、视频和工具，建造更年轻、更强壮的教会。',
        searchBar: '搜寻',
        resourceSearch: {
          bookSection: {
            header: '书籍',
          },
          quotesSection: {
            header: 'Quotes',
          },
          suggestionSection: {
            header: '你可能感兴趣……',
          },
        },
        backToTopSection: {
          otherContentText: '想看看其他资源？',
          backToTop: '回到顶部',
        },
        bookmarksSection: {
          header: '我的清单',
        },
      },
      sessionResourcesPage: {
        accessLiveInterpretation: '实时翻译',
        sessionResourcesheader: '课堂资源',
        assets: {
          toolsHeader: '工具',
          questionsHeader: '讨论时间问题',
          linksHeader: '相关资源',
        },
      },
      experiencePage: {
        title: '体验',
        description: '窥看幕后，看看“累代”和“强壮教会”的原则如何活灵活现！',
        note: '📢 查询你将参加的体验',
        experienceList: {
          title: '每位代表在累代牧师特会（区域性）期间可以参加 4 个体验中的 1 个:',
          exp1: '祷告会体验',
          exp2: '事工复盘',
          exp3: '小组聚会',
          exp4: '梦想与故事夜晚',
          note: '📢 你可在 {date}查询你所参加的体验。',
        },
        allocationPanel: {
          title: '你将参加',
          protipTitle: '💡专业小贴士：',
          protipHeader: '充分吸取体验的要点，思考以下问题:',
          protipQuestion1: '在我教会中可实践的有哪些？',
          protipQuestion2: '我要如何在我教会的环境中运用所学到的？',
          viewMapButton: '查看地图',
          viewMapButtonLink: 'https://cdn.generationsmvmt.com/docs/zh/HOGC-Map.pdf',
          viewFloorplanButton: '查看平面图',
          viewFloorplanButtonLink:
            'https://cdn.generationsmvmt.com/docs/zh/GPCR-Dream-and-Stories-Night-Floorplan.pdf',
        },
        carousel: {
          title: '了解全部{count}项体验',
          viewDetailsButton: '查看详情',
        },
      },
      schedulePage: {
        scheduleButton: '三天的行程表',
        schedule: 'https://cdn.generationsmvmt.com/docs/GPCR-2024-Schedule-ZH.pdf',
        dayOne: {
          day: '周五',
          dayNum: '15日',
          month: '11月',
          announcement: `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">你好</div>
              📣 报到前请先用早餐！记得带上耳机和外套！<br>`,
        },
        dayTwo: {
          day: '周六',
          dayNum: '16日',
          month: '11月',
          announcement: `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">周末到了！</div>
              📣 报到前请先用餐！<br>`,
        },
        dayThree: {
          day: '周日',
          dayNum: '17日',
          month: '11月',
          announcement:
            '<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">来到精彩万分的最后一天了！</div>📣 报到前请先用早餐！',
        },
        eventsCard: {
          accessLiveInterpretation: '实时翻译',
          seeSessionResources: '课堂资源',
          viewMapButtonLink: 'https://cdn.generationsmvmt.com/docs/zh/HOGC-Map.pdf',
        },
        // experienceHeader: "体验",
        checkAllocation: '查看分配',
        backToTop: '回到顶部',
      },
      photoDropPage: {
        photoDropActionBar: {
          myQR: '个人QR',
          select: '选择',
          cancel: '取消',
          download: '下载',
          downloading: '正在下载',
          noOfSelectedPhotosText: '已选择 { count } 张照片',
        },
        myPhotosTab: {
          tabName: '我的照片',
        },
        forEveryoneTab: {
          tabName: '所有人',
          videosTab: '视频',
          dayTab: '第{ i }天',
          viewMore: '查看更多',
        },
        personalTab: {
          tabName: '个人',
          subtitle: '带上朋友和摄影师，开始拍照吧！',
          qrCodeModal: {
            subtitle: '直接获取你的照片！',
            instructions: {
              one: '寻找任何穿着“PhotoDrop"白衣的神之心摄影师，并显示你的二维码！👕📸',
              two: '拉上你的朋友拍照，再回来浏览照片！',
            },
          },
        },
        customExperiencesTab: {
          tabName: '定制体验',
          subtitle: '你参加的体验照片将会上传到这里！🎁',
        },
        selectButton: '选择',
        downloadModal: {
          header: '通过电子邮件获取下载链接',
          description: '下载所选视频/照片的链接将发送到你的电邮。',
          sendToMyEmail: '发送链接到我的电邮',
          cancel: '取消',
        },
      },
      teamPage: {
        title: `<div class="font-aktiv-grotesk-medium mx-auto w-full xl:min-w-[360px] text-center xl:text-left text-[24px] leading-[32px]">
                      全球团队欢迎你!
                    </div>`,
        backRowText: '后排，从左到右:',
        backRowNames: {
          pastorMartin: 'Martin Wong牧师',
          blakeGladd: 'Blake Gadd',
          nataschaBruschweiler: 'Natascha Brüschweiler',
          nadineLeong: 'Nadine Leong (思慧)',
        },
        frontRowText: '前排，从左到右:',
        frontRowNames: {
          jamieLee: 'Jamie Lee',
          valerieFifi: 'Valerie Fifi',
          christianHonegger: 'Christian Honegger',
          tanJianMing: 'Tan Jian Ming',
        },
        meetTheFullLeadershipTeam: '认识整个领导团队！',
      },
      sideBar: {
        home: '首页',
        resources: '资源',
        schedule: '行程表',
        team: '团队',
        updates: '更新',
        termOfUse: '使用条款',
        privacyPolicy: '隐私政策',
      },
      bottomNav: {
        home: '首页',
        resources: '资源',
        schedule: '行程表',
        team: '团队',
        updates: '更新',
        more: '更多',
      },
      masterLayout: {
        logoutPopup: {
          message: '是否要退出？',
          continue: '继续',
          cancel: '取消',
        },
        newsLetterModal: {
          header: '与你的团队分享',
          description: `填写他们的姓名和电邮。<br>我们将会发送 GenS App 的邀请给他们！`,
          inputNamePlaceholder: '你朋友的名字',
          inputEmailPlaceholder: '你朋友的电邮',
          errorMessage: {
            emptyNameInput: '名字是必填项。',
            emptyEmailInput: '电邮是必填项。',
            notValidEmail: '请输入有效电邮。',
            errorOnSubmit: '提交表格时发生错误。请稍后再试。',
          },
          subscribe: '发送电邮邀请',
          sent: '发送',
        },
        filterModal: {
          resetFilters: '重置',
          applyFilters: '使用筛选',
          noItems: '暂无可用项目',
        },
      },
    },
  };
};

export default chineseTranslationContent;
